import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import { ShipmentDetailsPage } from '#/pages/shipment'
import { useShipmentSidebar } from '#/widgets/shipment-sidebar'

export const Route = createFileRoute('/_shell/quotes/$quoteId/')({
  component: DetailsRoute,
})

function DetailsRoute() {
  const { quoteId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/quotes', search: listSearch as never })
  }, [navigate, listSearch])
  const openShipmentSidebar = useShipmentSidebar(SHIPMENT_STAGES.QUOTE)
  const handleMinimize = useCallback(async () => {
    await navigate({ to: '/quotes', search: listSearch as never })
    openShipmentSidebar(quoteId)
  }, [navigate, listSearch, openShipmentSidebar, quoteId])
  return (
    <ShipmentDetailsPage
      stage={SHIPMENT_STAGES.QUOTE}
      shipmentId={quoteId}
      onClose={handleClose}
      onMinimize={() => void handleMinimize()}
    />
  )
}
